import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Props from '@components/Props';
export const _frontmatter = {
  "name": "Paragraph",
  "menu": "Components",
  "route": "/components/paragraph",
  "description": "The API documentation of the Paragraph React component. Play around with demos and check out its props."
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Paragraph`}</h1>
    <p><strong parentName="p">{`Paragraph`}</strong>{` is built on top of `}<a parentName="p" {...{
        "href": "https://material-ui.com/components/typography/"
      }}>{`Material-UI's Typography`}</a>{` and simply
extends it with a default `}<inlineCode parentName="p">{`width`}</inlineCode>{` and `}<inlineCode parentName="p">{`variant`}</inlineCode>{`. It was built to provide an optimal reading experience for text-contents
like in a blog.`}</p>
    <h2>{`Default`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<Paragraph>
  This is an awesome paragraph. It is based on the awesome material-ui Typography component. Its
  default variant is <code>body1</code>, and it has a maximal width of <b>650px</b>. According to awesome studies,
  it is the range where the eye feels the most comfortable reading. In addition to its variant,
  you can of course use all the{' '}
  <a href="https://material-ui.com/api/typography/" target="_blank" rel="noreferrer noopener">
    material-ui Typography component's props
  </a>
  .
</Paragraph>
`}</code></pre>
    <h2>{`Extended`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live-extended
<StyledParagraph>
  This is an awesome paragraph. It is based on the awesome material-ui Typography component. Its
  default variant is body1, and it has a maximal width of <b>650px</b>. According to awesome studies,
  it is the range where the eye feels the most comfortable reading. In addition to its variant,
  you can of course use all the{' '}
  <a href="https://material-ui.com/api/typography/" target="_blank" rel="noreferrer noopener">
    material-ui Typography component's props
  </a>
  .
</StyledParagraph>
`}</code></pre>
    <p>{`You can customize its width by leveraging the following `}<strong parentName="p">{`theme`}</strong>{` value:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const customTheme = {
  typography: {
    paragraph: {
      maxWidth: 42,
    },
  },
}
`}</code></pre>
    <h2>{`Props`}</h2>
    <p>{`This component extends Material's UI `}<inlineCode parentName="p">{`<Typography>`}</inlineCode>{` so you can use all its props as well. Check out its `}<a parentName="p" {...{
        "href": "https://material-ui.com/api/typography/"
      }}>{`Api`}</a>{`.`}</p>
    <Props of="Paragraph" mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      